import type { UIJSONSchema7, ParsedField } from "../types"

export function applyFieldOrdering(fields: ParsedField[], schema: UIJSONSchema7): ParsedField[] {
	const order = schema["x-order"]

	if (!order || !Array.isArray(order)) return fields

	const orderMap = new Map(order.map((name, index) => [name, index]))
	const orderedFields: ParsedField[] = []
	const unorderedFields: ParsedField[] = []

	for (const field of fields) {
		const orderIndex = orderMap.get(field.name)
		if (orderIndex !== undefined) {
			orderedFields.push({ ...field, order: orderIndex })
		} else {
			unorderedFields.push(field)
		}
	}

	orderedFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0))

	return [...orderedFields, ...unorderedFields]
}
